/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { deleteBlock, updateBlock } from "@/api/bot/flow/block";
import { IBlock, IBlockElement } from "@chatcaptain/types/chatbot";
import { deleteField, FieldValue, serverTimestamp, Timestamp } from "firebase/firestore";

export class Block {
  private flowId: string;
  private blockId: string;

  constructor(flowId: string, blockId: string) {
    this.flowId = flowId;
    this.blockId = blockId;
  }

  async updatePosition(x: number, y: number) {
    await this.update({
      grid: {
        uid: "",
        x,
        y,
      }
    });
  }

  async update(data) {
    await updateBlock(this.flowId, this.blockId, {
      ...data,
      updated: serverTimestamp() as Timestamp
    });
  }

  async delete() {
    await deleteBlock(this.flowId, this.blockId);
  }

  getFlowId(): string {
    return this.flowId;
  }

  getBlockId(): string {
    return this.blockId;
  }
}